module.exports = __webpack_public_path__ + "static/social-bg-d2ee48e04c1546f79746491f5d41d5aa.jpg";